// Phone photos are several MB each and a booking uploads several at once, which the
// server rejects. Shrink to a size that is still easy to read (IDs, faces).
export const compressImageFile = async (file, { maxDim = 1280, quality = 0.72, skipBelow = 350 * 1024 } = {}) => {
  try {
    if (!file || !/^image\//.test(file.type) || file.size <= skipBelow) return file;
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    if (bitmap.close) bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
    if (!blob || blob.size >= file.size) return file;
    const name = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
  } catch (error) {
    return file; // never block an upload because compression failed
  }
};
